import RegistrationList from './RegistrationList';

export default RegistrationList;
